export {
    DATA_TYPE_GROUP_SERVICE_NAME,
    DATA_TYPE_GROUP_SERVICE_PROVIDER_NAME,
    DataTypeGroupService,
    DataTypeGroupServiceProvider
} from './data-type-group.service'

export { DATA_TYPE_GROUP_SERVICES_MODULE_NAME } from './data-type-group.services.module'
